import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TemplateList from './TemplateList';
import TemplateForm from './TemplateForm';
import TemplateGenarateDocument from './TemplateGenarateDocument';

const TemplateRoutes = () => {
  return (
    <Routes>
      <Route index element={<TemplateList />} />
      <Route path="new" element={<TemplateForm />} />
      <Route path="edit/:id" element={<TemplateForm />} />
      <Route path="generate/:id" element={<TemplateGenarateDocument />} />
    </Routes>
  );
};

export default TemplateRoutes; 